
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nightvision",
      function () {
        return require("private-next-pages/nightvision.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nightvision"])
      });
    }
  